<template>
  <main class="tasks-page">
    <TopBar :page-header="$t('tasksPage.CMI')" />
    <div class="content">
      <table class="styled-table">
        <colgroup>
          <col width="30%">
          <col width="30%">
          <col width="40%">
        </colgroup>
        <thead>
          <tr v-if="Object1Exists()">
            <th>{{ $t('tasksPage.TaskDate') }}</th>
            <th>{{ $t('tasksPage.TaskNumber') }}</th>
            <th>{{ getObject1Name() }}</th>
            <!-- <th>{{objectnaming.object1.single}}  {{ $t('tasksPage.Number') }}</th> -->
          </tr>
          <tr v-else>
            <th>{{ $t('tasksPage.TaskDate') }}</th>
            <th>{{ $t('tasksPage.TaskNumber') }}</th>
            <th>{{ $t('tasksPage.Name') }}</th>
          </tr>
        </thead>
        <tbody>
          <template v-if="taskdata.length == 0">
            <tr v-if="!loading">
              <td colspan="3"
                  class="itemEmtypDataTd"
              >
                {{ $t('tasksPage.NothingToSee') }}
              </td>
            </tr>
            <tr v-else>
              <td td
                  colspan="3"
                  class="itemEmtypDataTd"
              >
                <div class="loaderDiv">
                  <LoaderComponent 
                    :size="30"
                  />
                </div>
                {{ $t('tasksPage.LoadingData') }}
              </td>
            </tr>
          </template>
          <template v-for="item in taskdata"
                    :key="item.Id"
          >
            <tr @click="ToggleHiddenItem(item)">
              <td class="itemHeaderTd">
                {{ item.StartDate }}
              </td><!-- LÄGG Värde här när det finns -->
              <td class="itemHeaderTd">
                {{ item.Nr }}
              </td>
              <td class="itemHeaderTd">
                {{ item.Location.Name }}
              </td>
            </tr>
            <tr>
              <td colspan="3"
                  :class="`itemDataTd ${!item.Hidden && 'is-expanded'}`"
              >
                <div :class="`expandable ${!item.Hidden && 'is-expanded'}`">
                  <RecursiveObjects v-if="!item.Hidden"
                                    :task-id="item.Id"
                                    :object="item"
                  />
                </div>
                
                <div v-if="checkControls(item)"
                     class="buttonRow"
                >
                  <button class="saveButton"
                          @click="SendDeviations(item)"
                  >
                    {{ $t('tasksPage.FinishCMIRow') }}
                  </button>
                </div>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
  </main>
</template>

<script setup>
import TopBar from "../components/TopBar.vue";
import RecursiveObjects from '@/components/RecursiveObjects.vue'
import { useToast } from "vue-toastification";
import i18n from '../locales/i18n'
const toast = useToast();
import { ref, computed, onMounted } from "vue";
import { useStore } from "vuex";
import { recursiveGetValues } from "@/utils/mobigoObject";
import LoaderComponent from "@/components/LoaderComponent.vue";

const store = useStore();

let taskdata = computed(() => store.state.tasks.taskdata);
let objectnaming = computed(() => store.state.tasks.objectnaming);

function checkControls(item){
  // let falseCount = 0;
  // let trueCount = 0;
 // let ServiceObjectCount = 0;
 if(item.Hidden){
  return false
  }else{
    return true;
  }
  //   const taskIndex = taskdata.value.findIndex((obj => obj.Id == item.Id));
  // for (const equipment of taskdata.value[taskIndex].Equipments) {
  //   //ServiceObjectCount += equipment.ServiceObjects.length
  //   for (const serviceObject of equipment.ServiceObjects) {
  //     if(serviceObject.HasDeviation == true){
  //       trueCount = trueCount+1;
  //     }
  //     else if (serviceObject.HasDeviation == false){
  //        falseCount = falseCount+1;return true;
  //     }
  //   }

    
  // }
  // if((trueCount+falseCount) == ServiceObjectCount && (trueCount+falseCount) != 0)
  //     return true;
  // else{
  //   return false
  //   }
}
function Object1Exists(){
  return objectnaming.value.object1 != null
}
function ToggleHiddenItem(item) {
  store.dispatch("tasks/getInspectionsForItemAndToggleHidden", item);
}

function SendDeviations(item){

  const taskIndex = taskdata.value.findIndex((obj => obj.Id == item.Id));
  const AllComplete = recursiveGetValues(taskdata.value[taskIndex].SubObjects)
  
  if(!AllComplete.includes(false)){
    store.dispatch("tasks/CompleteTask", item.InspectionId);
    //store.dispatch("tasks/FinishTask", parameters);
  }
  else
    toast.error(i18n.global.t("tasksPage.UncompletedObjects"), {
        timeout: 2500
      });
}

const loading = ref(true)
onMounted(async () => {
  loading.value = true
  store.commit('sidebar/setCurrentPageHeaderText', i18n.global.t('sidebar.tasks'));
  store.dispatch("tasks/getObjectNaming");
  await store.dispatch("tasks/getTaskData");
  loading.value = false
});

function getObject1Name(){
  if(window.siteConfig?.Object1Name){
    return window.siteConfig.Object1Name[i18n.global.locale]
  }
  return objectnaming.value.object1.single 
}

</script>

<style lang="scss" scoped>
@import "../scss/buttons.scss";
.tasks-page {
  height: 100vh;
  overflow-y: scroll;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #000000;
  background: white;
  .content {
    padding: 2rem;
  }
}

.buttonRow {
  width: 100%;
  height: 30px;
  .saveButton {
    @include btnBig;
    float: right;
    
    border: 1px solid var(--topbar);
    box-shadow: rgba(0, 0, 0, 0.15) 3px 3px 3px;
    padding: 0px;
    background: #4F0207;
    color: #ffffff;
    font-size: 14px;
    font-weight: 600;
    text-transform: none;
    border-radius: 999px;

    &:hover {
      border-radius: 999px;
    }

    &:active{
      background: #4F0207;
      color: #ffffff;
    }
  }
}


.equipmentcard {
  background: var(--dark_transparent);
  border-radius: 5px;
  padding: 5px;
  margin-bottom: 7px;
  margin-right: 4px;
  box-shadow: rgba(0, 0, 0, 0.45) 3px 3px 3px;
}

.styled-table {
  table-layout: fixed;
  border-collapse: collapse;
  margin: 25px 0;
  font-family: "Be Vietnam Pro", sans-serif;
  font-size: 12px;
  width: 100%;
}

.styled-table thead tr {
  background-color: #ffffff;
  color: #000000;
  text-align: left;
  border-bottom: 1px solid #777777;
}

.styled-table th {
  padding: 8px 10px;
  text-align: left;
  text-overflow:ellipsis;
  overflow:hidden;
  white-space: nowrap;
  color: #000000;
  font-weight: 600;
}

.itemHeaderTd {
  padding: 10px;
  text-align: left;
  font-weight: 400;
  cursor: pointer;
  word-wrap: break-word;

}
.itemDataTd {
  padding: 0px 15px;
  text-align: left;
  transition: padding 0.4s ease;
  &.is-expanded {
    padding: 12px 15px;
    transition: padding 0.4s ease;
  }
}
.itemEmtypDataTd{
    text-align: center;
    padding: 12px 15px;
    font-size: 0.9em;
    font-weight: bold;
}
.loaderDiv{
  width: 100%;
  
  display: flex;
  justify-content: space-around;
}
.styled-table tbody tr {
  border-bottom: 1px solid #dddddd;
  background-color: #E6E6E6;

  .expandable {
    overflow: hidden;
    //max-height:0;
    //transition: max-height 1.0s ease;

    height: 0;
    transition: height 1s ease;

    &.is-expanded {
      //max-height: 500px;
      //transition: max-height 1.0s ease;
      height: auto;
      transition: height 1s ease;
    }
  }
}

.styled-table tbody tr:nth-of-type(4n-1),
.styled-table tbody tr:nth-of-type(4n) {
  background-color: #ffffff;
}

.styled-table tbody tr:last-of-type {
  border-bottom: 3px solid var(--primary);
}

@media(max-width:768px) {
      .tasks-page .content{
        padding: 0px;
        min-width: unset;
        width: 100%;
      }

      .styled-table {
        margin: 0;
        font-family: "Be Vietnam Pro", sans-serif;
        font-size: 8px;
      }

      .styled-table thead tr {
        background-color: #ffffff;
        color: #000000;
        border-bottom: 1px solid #777777;
      }

      .styled-table th {
        padding: 7px 4px;
        color: #000000;
        font-weight: 600;
      }

      .itemHeaderTd {
        padding: 14px 4px;
        font-weight: 400;
      }

      .itemDataTd.is-expanded {
        padding: 8px 4px;
      }
  }
</style>
